module.exports = __webpack_public_path__ + "img/food-force-background.97f6d85c.jpg";